import type { TabKey } from "../session/tab-context";

// Le chiavi di cache dei Task (piano M5, Task 18), in un modulo senza altre dipendenze: le usano la pagina «Le cose da fare», il
// banner del richiamo concordato (Task 20), la scheda del Lead dopo un richiamo fissato o spostato, e la telefonia dopo una
// chiamata, che può aver completato un richiamo.

export const taskKeys = {
  /** Tutto ciò che la scheda ha letto dei Task: il prefisso delle altre chiavi. */
  all: (tab: TabKey) => ["scheda", tab, "tasks"] as const,
  /** Le pagine dell'agenda di una scheda, «Di chi», «Cosa» e ordine, in una vista (`null` fuori dalla «Guarda come…»). */
  list: (tab: TabKey, view: string | null, query: unknown) => ["scheda", tab, "tasks", "list", view, query] as const,
  /** I richiami concordati con l'ora arrivata, per il banner del guscio (Task 20): una chiamata o un richiamo li fanno rileggere. */
  dueNow: (tab: TabKey, view: string | null) => ["scheda", tab, "tasks", "due-now", view] as const,
};
